var map = {
	"./Authentication/Authentication/routes.js": 5135,
	"./Finances/Bonus/routes.js": 5826,
	"./Finances/Credit/routes.js": 9184,
	"./Finances/Deposit/routes.js": 4791,
	"./Finances/Finances/routes.js": 7343,
	"./Finances/History/routes.js": 1855,
	"./Finances/Wallet/routes.js": 9934,
	"./Finances/Withdraw/routes.js": 5077,
	"./Profile/Profile/routes.js": 4364,
	"./Trading/Trading/routes.js": 397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5647;